//@ts-ignore
import { Handle, Position } from "@xyflow/react";
import { ICONS } from "./nodeTypes";

const HANDLES = [
  { type: "target", position: Position.Top, id: "top" },
  { type: "target", position: Position.Left, id: "left" },
  { type: "source", position: Position.Right, id: "right" },
  { type: "source", position: Position.Bottom, id: "bottom" },
];

const CustomNode = ({ data, isConnectable }) => {
  const { icon, label } = data;

  const Icon = ICONS[icon];

  return (
    <div className="workflow-node">
      {HANDLES.map(({ type, position, id }) => (
        <Handle
          key={id}
          //@ts-ignore
          type={type}
          position={position}
          id={id}
          isConnectable={isConnectable}
          className="workflow-handle"
        />
      ))}

      <div className="workflow-node-content">
        <div className="workflow-node-header">
          {Icon && <Icon className="workflow-node-icon" />}
          <span className="workflow-node-title">{label}</span>
        </div>
        <div className="workflow-node-status" style={{ color: "#3b82f6" }}>
          {data.subLabel}
        </div>
      </div>
    </div>
  );
};

export default CustomNode;
